var React = require('react');

function ShevronDown (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#cliprw0)","key":0},React.createElement("path",{"d":"M11.5037 14.9014L1.31979 7.30982C0.828626 6.94368 0.828626 6.35009 1.31979 5.984L2.50758 5.09857C2.9979 4.73306 3.79257 4.73235 4.28405 5.097L12.393 11.1135L20.5019 5.097C20.9934 4.73235 21.7881 4.73306 22.2784 5.09857L23.4662 5.984C23.9573 6.35013 23.9573 6.94372 23.4662 7.30982L13.2823 14.9014C12.7912 15.2675 11.9949 15.2675 11.5037 14.9014Z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"cliprw0"},React.createElement("rect",{"width":"23.476","height":"20","fill":"white","transform":"translate(0.655029)"})))]);
}

ShevronDown.defaultProps = {"width":"25","height":"20","viewBox":"0 0 25 20","fill":"color"};

module.exports = ShevronDown;

ShevronDown.default = ShevronDown;
